import React from "react";
import { InputNumber } from "antd";

const CustomNumOfAmt = ({ value, ...props }) => {
  function format(num) {
    return num.toString().replace(/^[+-]?\d+/, function (int) {
      return int.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
    });
  }

  return (
    <InputNumber
      style={{ width: "100%" }}
      value={value}
      placeholder="0,00"
      defaultValue={value}
      formatter={format}
      parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
      {...props}
    />
  );
};

export default CustomNumOfAmt;
